<template>
  <div v-loading="infoLoading">
    <!-- tab栏 -->
    <ContentHeader path-set-type="replace" />
    <div class="content-container">
      <!-- 订单基本信息 -->
      <OrderBaseInfo
        :tradeApplyOrderVO="tradeApplyOrderVO"
        :tradeApplyInfoVO="tradeApplyInfoVO"
        :tradeApplyBaseVO="tradeApplyBaseVO"
        :isMineApply="isMineApply"
        @handleSuccess="init"
      >
        <!-- 订单状态进度 -->
        <OrderStepInfo ref="OrderStepInfo" :tradeApplyOrderVO="tradeApplyOrderVO" />
      </OrderBaseInfo>

      <!-- 完美门店参与资格 -->
      <div class="trade-order-block" style="display: flex; align-items: center" v-if="tradeApplyExecStack && tradeApplyInfoVO.applyStatus === '500'">
        <div class="block-title">门店完美门店参与资格</div>
        <div style="margin-left: 50px">
          <el-switch disabled v-model="tradeApplyBaseVO.isStack" active-color="#409EFF" inactive-color="#C0CCDA" @click.native="stackSwitch"></el-switch>
        </div>
      </div>

      <!-- PBO计划参与资格 -->
      <div class="trade-order-block" style="display: flex; align-items: center" v-if="tradeApplyExecPboDTO && tradeApplyInfoVO.applyStatus === '300'">
        <div class="block-title">门店PBO计划参与资格</div>
        <div style="margin-left: 50px">
          <el-switch disabled v-model="tradeApplyExecPboDTO.attendStatus" active-color="#409EFF" inactive-color="#C0CCDA"></el-switch>
        </div>
      </div>

      <!-- 补充wccsid/截图 -->
      <OrderSupplementInfo ref="OrderSupplementInfo" v-show="supplementShow" @supplementSucc="init" />

      <!-- 费用审批 - 选择预算等 -->
      <div class="quota-info" v-show="budgetSelectShow">
        <div class="info-title" @click="collClick(4)">
          <i :class="[quotaShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          配额信息
        </div>
        <OrderBudgetSelect v-show="quotaShow" :tradeApplyOrderVO="tradeApplyOrderVO" :approvalFormData="approvalFormData" :budgetSelectShow="budgetSelectShow" />
      </div>

      <!-- 上传DAG凭证 -->
      <UploadDag
        v-if="canUpload"
        :isEdit="orderQuotaPickerShow"
        :imageList="approvalFormData.tradeApplyDagFileList"
        @onUploadSuccess="handleUploadSuccess"
        @onFileRemove="handleFileRemove"
      />

      <!-- 审批概览 -->
      <!-- <OrderExpenseInfo ref="OrderExpenseInfo" v-show="isMineApproval && expenseInfoShow"/> -->

      <!-- bu 审批 配额信息 -->
      <div class="quota-bu-info" v-if="tradeApplyInfoVO.solutionStatus >= 260 && tradeApplyInfoVO.trCode">
        <div class="info-title" @click="collClick(6)">
          <i :class="[buQuotaShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          配额信息
        </div>
        <div v-show="buQuotaShow">
          <OrderQuotaInfo ref="OrderQuotaInfo" :tradeApplyInfoVO="tradeApplyInfoVO"></OrderQuotaInfo>
        </div>
      </div>
      <!-- 方案明细 -->
      <div class="order-info" v-show="planDetailShow">
        <div class="info-title" @click="collClick(2)">
          <i :class="[planShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          {{ tradeApplyOrderVO.applyType === '02' ? '报价详情' : '方案明细' }}
        </div>
        <div v-show="planShow">
          <OrderPlanDetail ref="OrderPlanDetail" />
        </div>
      </div>

      <!-- 验收详情 -->
      <div class="order-info" v-show="acceptDetailShow">
        <div class="info-title" @click="collClick(3)">
          <i :class="[acceptShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          验收详情
        </div>
        <div v-show="acceptShow">
          <OrderAcceptDetail ref="OrderAcceptDetail" />
        </div>
      </div>

      <!-- 分配服务商 - 210-->
      <div class="trade-order-block" v-show="canSupplier && tradeApplyInfoVO.applyStatus !== '900'">
        <div class="block-title">分配服务商</div>
        <div class="block-content">
          <el-row class="content-row">
            <el-col :span="3">选择服务商</el-col>
            <el-col :span="9">
              <el-select v-model="approvalFormData.vendorId" placeholder="请选择服务商" size="small" clearable filterable style="width: 400px">
                <el-option v-for="item in vendorList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId" />
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 配额信息 -->
      <div class="quota-info" v-if="tradeApplyExecCooler" v-show="isMineApproval && tradeApplyInfoVO.acceptanceStatus !== '410'">
        <div class="info-title" @click="collClick(4)">
          <i :class="[quotaShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          配额信息
        </div>
        <div v-show="quotaShow" class="trade-order-block">
          <el-table
            :data="tradeApplyExecCooler.tradeApplyExecCoolerList"
            style="border-radius: 5px; margin: 0 auto"
            :cell-style="tableBorderRight"
            :header-row-class-name="tableHeaderRowClassName"
          >
            <el-table-column prop="date" align="center">
              <el-table-column prop="coolerName" label="型号" align="center" :border="false"></el-table-column>
            </el-table-column>
            <el-table-column prop="date" label="全年配额" align="center">
              <el-table-column prop="tradeCoolerBudgetInfo.availableAmount" label="可使用" align="center"></el-table-column>
              <el-table-column prop="tradeCoolerBudgetInfo.freezeAmount" label="冻结中" align="center"></el-table-column>
              <el-table-column prop="tradeCoolerBudgetInfo.usedAmount" label="已使用" align="center"></el-table-column>
            </el-table-column>
            <el-table-column prop="date" label="当前季度配额" align="center">
              <el-table-column prop="curQuarterQuotaInfo.availableQuota" label="可使用" align="center"></el-table-column>
              <el-table-column prop="curQuarterQuotaInfo.trFreezeQuota" label="冻结中" align="center"></el-table-column>
              <el-table-column prop="curQuarterQuotaInfo.trUsedQuota" label="已使用" align="center"></el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 门店投入信息 -->
      <!-- 门店定制 选店标准和历史投入 -->
      <!-- star店招计划 历史投入 -->
      <div
        class="investment-info"
        v-if="
          (tradeApplyExecVO && ['102', '201'].includes(tradeApplyExecVO.execTypeSub) && (showHistoryInvestment || tradeApplyOrderPocCheckInfo)) ||
          (tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '202' && showHistoryInvestment)
        "
      >
        <div class="info-title" @click="collClick(5)">
          <i :class="[investmentShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          门店投入信息
        </div>
        <div v-show="investmentShow">
          <div
            v-if="
              tradeApplyExecVO && ['102', '201'].includes(tradeApplyExecVO.execTypeSub) && tradeApplyExecVO.execTypeSub !== '202' && tradeApplyOrderPocCheckInfo
            "
            class="trade-order-block"
          >
            <div class="block-title">
              选店标准
              <span class="standard-title" @click="showCompleteStandard">
                <img src="@/assets/images/doubt.png" alt />
              </span>
            </div>
            <table v-for="(itemList, key) in tradeApplyOrderPocCheckInfo" :key="key" class="investment-table">
              <th :class="checkStandardAll(itemList) ? 'isMeet' : 'Meet'">
                {{ key }}
                <i v-if="checkStandardAll(itemList)">
                  <img src="@/assets/images/conformity.png" alt />
                </i>
                <i v-else>
                  <img src="@/assets/images/no-conformity.png" alt />
                </i>
              </th>
              <th>地理位置</th>
              <th>门店特征</th>
              <th>人均消费</th>
              <tr>
                <td>选店标准</td>
                <td v-for="(item, index) in itemList" :key="index">{{ item.checkStandard }}</td>
              </tr>
              <tr>
                <td>当前门店</td>
                <td v-for="(item, index) in itemList" :key="index" :class="item.isMatch ? '' : 'Meet'">{{ item.pocValue }}</td>
              </tr>
            </table>
          </div>
          <div class="trade-order-block" v-if="showHistoryInvestment">
            <div class="block-title">历史投入</div>
            <div class="history-investment-box">
              <div class="history-investment" v-if="historyInvestmentInfo.money.detailList && historyInvestmentInfo.money.detailList.length">
                <div class="investment-title">
                  <span>现金</span>
                  <span> {{ historyInvestmentInfo.money.totalAmount | thousandSymbol }}元 </span>
                </div>
                <div class="investment-content">
                  <div v-for="(item, index) in historyInvestmentInfo.money.detailList" :key="index">
                    <span>{{ item.execTypeSubName }}</span>
                    <span>{{ item.amount | thousandSymbol }}元</span>
                  </div>
                </div>
              </div>
              <div class="history-investment" v-if="historyInvestmentInfo.cooler.detailList && historyInvestmentInfo.cooler.detailList.length">
                <div class="investment-title">
                  <span>冰柜</span>
                  <span> {{ historyInvestmentInfo.cooler.totalAmount | thousandSymbol }}台 </span>
                </div>
                <div class="investment-content">
                  <div v-for="(item, index) in historyInvestmentInfo.cooler.detailList" :key="index">
                    <span>{{ item.coolerName }}</span>
                    <span>{{ item.amount | thousandSymbol }}台</span>
                  </div>
                </div>
              </div>
              <div class="history-investment" v-if="historyInvestmentInfo.beer.detailList && historyInvestmentInfo.beer.detailList.length">
                <div class="investment-title">
                  <span>免费酒</span>
                  <span> {{ historyInvestmentInfo.beer.totalAmount | thousandSymbol }}箱 </span>
                </div>
                <div class="investment-content">
                  <div v-for="(item, index) in historyInvestmentInfo.beer.detailList" :key="index">
                    <span>{{ item.beerName }}</span>
                    <span>{{ item.amount | thousandSymbol }}箱</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-dialog
            :visible.sync="completeStandardDialog"
            :close-on-click-modal="false"
            width="900px"
            :title="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '102' ? '资产冰柜完整标准' : '门店定制完整标准'"
          >
            <div class="complete-standard-info">
              <img v-if="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '102'" src="@/assets/images/cooler-standard.png" alt />
              <img v-else src="@/assets/images/store-standard.png" alt />
            </div>
          </el-dialog>
        </div>
      </div>
      <!-- 订单明细 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(0)">
          <i :class="[orderShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          订单明细
        </div>
        <div v-show="orderShow">
          <!-- 门店基础信息 -->
          <StoreBaseInfo
            v-if="(tradeApplyOrderVO.applyType !== '02' && basePocInfo.abiOneId) || tradeApplyOrderVO.applyType === '04'"
            ref="StoreBaseInfo"
            :tradeApplyOrderVO="tradeApplyOrderVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :basePocInfo="basePocInfo"
          />
          <PocBaseInfo
            v-if="tradeApplyOrderVO.applyType !== '02' && !basePocInfo.abiOneId && tradeApplyOrderVO.applyType !== '04'"
            ref="pocBaseInfo"
            :tradeApplyOrderVO="tradeApplyOrderVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :basePocInfo="basePocInfo"
            :tradeApplyBaseVO="tradeApplyBaseVO"
          />

          <!-- 门店执行信息 -->
          <!-- 高端店招 -->
          <!-- <OrderExecHigh
            v-if="tradeApplyExecVO && tradeApplyExecVO.execTypeSub === '101'"
            :tradeApplyExecVO="tradeApplyExecVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
          />-->
          <!-- 资产冰柜 -->
          <OrderExecCooler
            v-if="tradeApplyExecCooler"
            :tradeApplyExecVO="tradeApplyExecVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :tradeApplyExecCooler="tradeApplyExecCooler"
          />
          <!-- 物料定制 -->
          <!-- 判断当前的项目是否是定制 -->
          <OrderExecMaterial
            v-if="tradeApplyExecCustom"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :tradeApplyExecCustom="tradeApplyExecCustom"
          />
          <!-- isp -->
          <OrderExecIsp
            v-if="ispOrderData"
            :tradeApplyExecVO="tradeApplyExecVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :ispOrderData="ispOrderData"
          />

          <!-- 门店执行信息 - 非批量化物料 -->
          <StoreExecInfo ref="StoreExecInfo" v-if="tradeApplyOrderVO.applyType !== '02' && !isChannelType" />
          <!-- 批量化物料 -->
          <StoreBulkInfo ref="StoreBulkInfo" />
        </div>
      </div>

      <!-- 操作记录 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(1)">
          <i :class="[processShow ? 'el-icon-minus' : 'el-icon-plus']"></i>
          操作记录
        </div>
        <div v-show="processShow">
          <OrderProcessInfo ref="OrderProcessInfo" :processRecordList="processRecordList" />
        </div>
      </div>

      <!-- 订单评价 -->
      <OrderCommentInfo ref="OrderCommentInfo" />

      <!-- 操作按钮 -->
      <div class="order-info info-btn" v-show="isMineApproval && tradeApplyInfoVO.acceptanceStatus !== '410'">
        <div :class="{ fixed: isFixed }">
          <el-button v-if="canReject" class="btn-red-plain" size="small" @click="handleReject">驳回</el-button>
          <el-button v-if="canPass" class="btn-red" size="small" @click="handlePass">通过</el-button>
          <el-button v-if="canAccept" class="btn-red" size="small" @click="handleAccept">验收</el-button>
          <el-button v-if="canSupplier || supplierSelectShow" class="btn-red" size="small" @click="handleSupplier">提交服务商</el-button>
          <el-button v-if="canReceipt" class="btn-red" size="small" @click="handleReceipt">去收货</el-button>
        </div>
      </div>

      <!-- 弹窗提示 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" @close="cancel" width="30%" style="min-width: 430px">
        <span v-if="handleText">{{ handleText }}</span>
        <div v-else>
          <div class="block-content">
            <el-row class="content-row" style="margin-bottom: 10px" v-show="(supplierSelectShow || supplierSelectShowOn130) && handleType !== 'reject'">
              <el-col :span="6"> <i style="color: #c8102d; font-weight: 700; margin-right: 3px">*</i>选择服务商 </el-col>
              <el-col :span="9">
                <el-select v-model="approvalFormData.vendorId" placeholder="请选择服务商" size="small" clearable filterable style="width: 270px">
                  <el-option v-for="item in vendorList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId" />
                </el-select>
              </el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="6" style="min-width: 100px">
                <i v-if="handleType === 'reject'" style="color: #c8102d; font-weight: 700; margin-right: 3px">*</i>
                {{ handleType === 'reject' ? '填写驳回理由' : '填写审批建议' }}
              </el-col>
              <el-col :span="9">
                <el-input
                  style="width: 270px; height: 50px"
                  type="textarea"
                  :placeholder="handleType === 'reject' ? '请填写驳回理由' : '请填写审批建议'"
                  v-model="approvalFormData.processRemark"
                ></el-input>
              </el-col>

            </el-row>
            <div style="margin-top:10px;" v-if="showAcceptTip">注意：验收成功后触发PR审批和PO创建流程。</div>
            <!-- <el-input style="width:75%" placeholder="请填写审批建议" v-model="approvalFormData.processRemark"></el-input> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancel">取 消</el-button>
          <el-button class="btn-red" size="small" @click="e => handleConfirm(false)" :loading="btnLoading">{{
            handleType === 'reject' ? '驳 回' : '确 定'
          }}</el-button>
        </span>
      </el-dialog>

      <!-- 成功弹窗 -->
      <el-dialog title="提示" :visible.sync="succVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <span>{{ successText }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="returnList">返回</el-button>
          <el-button class="btn-red" size="small" @click="showInfo">查看详情</el-button>
        </span>
      </el-dialog>

      <!-- 评价弹窗 -->
      <OrderCommentDialog ref="OrderCommentDialog" @commentSuccess="commentSuccess" />

      <!-- 预算弹框 -->
      <OrderBudgetDialog ref="OrderBudgetDialog" :budgetCheckPassed="budgetCheckPassed" :budgetCheckFailed="budgetCheckFailed" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tradeApi from '@/api/trade.js'
import { localStorageUtils } from '@/utils/localstorage'
import ContentHeader from '@/components/content-header'
import OrderBaseInfo from './components/order-base-info'
import OrderStepInfo from './components/order-step-info'
import StoreBaseInfo from './components/store-base-info'
import StoreExecInfo from './components/store-exec-info'
import OrderProcessInfo from './components/order-process-info'
import StoreBulkInfo from './components/store-bulk-info'
import OrderBudgetSelect from './components/order-budget-select'
// import OrderExpenseInfo from './components/order-expense-info'
import OrderQuotaInfo from './components/order-quota-Info'
import OrderPlanDetail from './components/order-plan-detail'
import OrderAcceptDetail from './components/order-accept-detail'
import OrderSupplementInfo from './components/order-supplement-info'
import OrderCommentInfo from './components/order-comment-info'
import OrderCommentDialog from './components/order-comment-dialog'

import PocBaseInfo from './components/poc-base-info'
import OrderExecCooler from './components/order-exec-cooler'
import OrderExecMaterial from './components/order-exec-material'
import OrderExecIsp from './components/order-exec-isp'
import UploadDag from './components/upload-dag'

import OrderBudgetDialog from './components/order-budget-dialog'

export default {
  name: 'trade-order-info',
  components: {
    ContentHeader,
    OrderBaseInfo,
    OrderStepInfo,
    StoreBaseInfo,
    StoreExecInfo,
    OrderProcessInfo,
    StoreBulkInfo,
    OrderBudgetSelect,
    // OrderExpenseInfo,
    OrderPlanDetail,
    OrderAcceptDetail,
    OrderSupplementInfo,
    OrderCommentInfo,
    OrderCommentDialog,
    PocBaseInfo,
    OrderExecCooler,
    OrderExecMaterial,
    OrderExecIsp,
    UploadDag,
    OrderQuotaInfo,
    OrderBudgetDialog
  },
  data () {
    return {
      tradeApplyOrderVO: '', // 订单的信息
      tradeApplyInfoVO: '',
      tradeApplyBaseVO: '',
      tradeApplyBizVO: '',
      tradeApplyExecVO: '',
      tradeApplyExecCooler: '',
      tradeApplyExecCustom: '', // 物料定制信息
      tradeApplyExecStack: '',
      tradeApplyProcessRecordVO: '',
      tradeBmApplyDetailList: '',
      tradeBmApplyImageList: '',
      processRecordList: [],
      ispOrderData: '',
      tradeApplyExecPboDTO: '',
      employeeLevel: null,
      defaultBuType: '',
      vendorList: [],
      execTypeSub: '',

      infoLoading: false,
      btnLoading: false,
      orderShow: true,
      processShow: true,
      planShow: true,
      acceptShow: true,
      quotaShow: true,
      investmentShow: true,
      buQuotaShow: true,

      isMineApproval: false,
      isMineApply: false,
      dialogVisible: false,
      succVisible: false,
      handleType: '',
      handleText: '',
      successText: '',

      // 按钮权限
      canReject: false,
      canPass: false,
      canAccept: false,
      canSupplier: false,
      canReceipt: false,
      supplierSelectShow: false,
      supplierSelectShowOn130: false,

      expenseInfoShow: false,
      budgetSelectShow: false,
      planDetailShow: false,
      acceptDetailShow: false,
      supplementShow: false,

      approvalFormData: {
        applyId: '',
        approvalResult: '', // 01提交，02审批通过，03审批退回
        processRemark: '', // 如驳回，驳回理由
        vendorId: '', // 服务商
        processClientId: '', // 操作人Id
        processClientName: '', // 操作人名字
        trCode: '', // TRCode
        quotaId: '', // 配额ID
        ledgerAccount: '', // 总账科目
        companyEntityCode: '',
        costCenterCode: '', // 成本中心
        mmr12: '', // mmr12
        clientType: '', // 用户类型 01百威 02ISP
        applyType: '', // 对应申请单类型 01高端店招 02物料定制 03批量化物料 04完美门店
        approvalType: '', // 01需求审批 02费用审批 03验收审批
        tradeApplyExecCoolerList: [], // 资产冰柜
        tradeApplyDagFileList: []
      },

      isFixed: true,

      commentVisible: false,
      commentParams: {
        applyId: '',
        qualityScoreValue: '',
        speedScoreValue: '',
        tmComment: ''
      },
      hasComment: false,

      basePocInfo: '',

      tradeApplyOrderPocCheckInfo: null,

      completeStandardDialog: false,
      historyInvestmentInfo: {},
      budgetCheckPassed: '',
      budgetCheckFailed: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 订单选择配额信息
    orderQuotaPickerShow () {
      return (
        this.isMineApproval &&
        (([45, 50].includes(this.employeeLevel) &&
          this.tradeApplyInfoVO.solutionStatus === '250') ||
          (this.tradeApplyInfoVO.applyClientLevel === 60 &&
            this.employeeLevel === 60 &&
            this.tradeApplyInfoVO.solutionStatus === '270')) &&
        this.tradeApplyInfoVO.applyStatus === '200'
      )
    },
    // 是否是渠道项目
    isChannelType () {
      return (
        (this.tradeApplyExecVO && this.tradeApplyOrderVO.applyType !== '04') ||
        this.tradeApplyExecCooler ||
        this.tradeApplyExecCustom ||
        this.ispOrderData
      )
    },
    // 是否显示历史投入
    showHistoryInvestment () {
      if (!this.historyInvestmentInfo) {
        return false
      }
      return !!(
        this.historyInvestmentInfo.money?.detailList?.length ||
        this.historyInvestmentInfo.cooler?.detailList?.length ||
        this.historyInvestmentInfo.beer?.detailList?.length
      )
    },

    canUpload () {
      return (
        (this.orderQuotaPickerShow &&
          Number(this.tradeApplyInfoVO.quoteNonMenuAmount) >= 50000) ||
        (!this.orderQuotaPickerShow &&
          this.tradeApplyOrderVO.tradeApplyDagFileList?.length &&
          this.employeeLevel >= 40)
      )
    },
    needCheckPoc () {
      return !!(this.tradeApplyExecVO && ['102', '105','111', '113', '201', '202', '302', '303'].includes(this.tradeApplyExecVO.execTypeSub) && this.basePocInfo.abiPocId && this.tradeApplyInfoVO.applyStatus < 300)
    },
    isStarCustom () {
      return !!(this.tradeApplyExecVO?.execTypeSub === '202' && this.employeeLevel === 90)
    },
    showAcceptTip(){
      let approvalType = ''
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      if (applyStatus === '100') approvalType = '01'
      if (applyStatus === '200') approvalType = '02'
      if (applyStatus === '400') approvalType = '03'
      return  approvalType === '03' &&  this.tradeApplyInfoVO.acceptanceStatus === '420' && this.handleType !== 'reject'
    }
  },
  mounted () {
    this.init()
    const _self = this
    window.onscroll = function () {
      _self.isFixed = true
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        _self.isFixed = false
      }
    }
  },
  methods: {
    init () {
      this.getOrderInfo()
      this.tradeApplyApproveInfo()
    },
    // 点击取消
    cancel () {
      this.approvalFormData.processRemark = ''
      this.dialogVisible = false
    },
    // 获取订单信息
    getOrderInfo () {
      this.infoLoading = true
      this.$store
        .dispatch('getOrderInfo', this.$route.query.applyId)
        .then((res) => {
          this.infoLoading = false
          if (res.data.resultCode === '0') {
            this.tradeApplyOrderVO = res.data.resultData.tradeApplyOrderVO // 订单的信息
            this.tradeApplyInfoVO = this.tradeApplyOrderVO.tradeApplyInfoVO // 订单的信息
            this.tradeApplyBaseVO = Object.assign(
              {},
              this.tradeApplyOrderVO.basePocInfo,
              this.tradeApplyOrderVO.tradeApplyBaseVO
            )
            this.tradeApplyBizVO =
              this.tradeApplyOrderVO.tradeApplyBizVO ||
              this.tradeApplyOrderVO.basePocInfo
            this.tradeApplyExecVO = this.tradeApplyOrderVO.tradeApplyExecVO
            this.tradeApplyExecCooler =
              this.tradeApplyOrderVO.tradeApplyExecCooler
            this.tradeApplyExecCustom = // 物料定制
              this.tradeApplyOrderVO.tradeApplyExecCustom
            this.tradeApplyExecStack =
              this.tradeApplyOrderVO.tradeApplyExecStack
            this.tradeApplyProcessRecordVO =
              this.tradeApplyOrderVO.tradeApplyProcessRecordVO
            this.tradeBmApplyDetailList =
              this.tradeApplyOrderVO.tradeBmApplyDetailList
            this.tradeBmApplyImageList =
              this.tradeApplyOrderVO.tradeBmApplyImageList
            this.processRecordList =
              this.tradeApplyOrderVO.processRecordList || []
            this.ispOrderData = this.tradeApplyOrderVO.ispOrderData
            this.tradeApplyExecPboDTO =
              this.tradeApplyOrderVO.tradeApplyExecPboDTO
            this.basePocInfo = this.tradeApplyOrderVO.basePocInfo

            if (this.isChannelType) {
              this.$nextTick(() => {
                if (this.$refs.pocBaseInfo) {
                  this.$refs.pocBaseInfo.initMap(this.basePocInfo)
                }
              })
            }
            // if (this.tradeApplyExecVO.execTypeSub === '101' || this.tradeApplyExecVO.execTypeSub === '102') {
            //   this.getApprovePocCheckStandard(this.tradeApplyExecVO.execTypeSub)
            // }
            // 审批人是否是本人
            if (
              this.userInfo.clientId ===
              this.tradeApplyInfoVO.approvalClientId ||
              (this.userInfo.regionTMClientId ===
                this.tradeApplyInfoVO.approvalClientId &&
                this.userInfo.employeeLevel === 45)
            ) {
              this.isMineApproval = true
            } else {
              this.isMineApproval = false
            }

            // 是否是本人提报
            this.isMineApply =
              this.userInfo.clientId === this.tradeApplyInfoVO.applyClientId

            // 进度条
            this.$refs.OrderStepInfo.setOrderStatusList(this.tradeApplyOrderVO)

            // 非批量化物料
            if (
              this.tradeApplyOrderVO.applyType === '01' ||
              this.tradeApplyOrderVO.applyType === '03'
            ) {
              // 补充信息
              this.$refs.OrderSupplementInfo.setShowInfo(
                this.tradeApplyOrderVO,
                this.userInfo
              )

              // if (!this.tradeApplyExecCooler) {
              this.$nextTick(() => {
                if (this.$refs.StoreBaseInfo) {
                  this.$refs.StoreBaseInfo.initMap(this.tradeApplyBaseVO)
                }
              })
              // }
              if (!this.isChannelType) {
                this.$refs.StoreExecInfo.setExecInfo(this.tradeApplyOrderVO)
              }
            } else if (this.tradeApplyOrderVO.applyType === '04') {
              if (!this.isChannelType) {
                this.$refs.StoreExecInfo.setExecInfo(this.tradeApplyOrderVO)
              }
              const mapInfo = {}
              this.tradeApplyExecPboDTO.tradePboCirclePocList.forEach(
                (item) => {
                  if (item.pocType === 'main') {
                    mapInfo.locLatitude = item.circlePocLat
                    mapInfo.locLongitude = item.circlePocLong
                    mapInfo.pocName = item.circlePocName
                    mapInfo.detailAddress = item.circlePocAddress
                  }
                }
              )
              this.$nextTick(() => {
                if (this.$refs.StoreBaseInfo) {
                  this.$refs.StoreBaseInfo.initMap(mapInfo)
                }
              })
            } else {
              this.$refs.StoreBulkInfo.setBulkInfo(this.tradeApplyOrderVO)

            }
            // 审批概览
            // this.$refs.OrderExpenseInfo.setExpenseInfo(this.tradeApplyOrderVO)

            this.$nextTick(() => {
              // 方案明细
              this.$refs.OrderPlanDetail.setPlanInfo(this.tradeApplyInfoVO)

              // 验收详情
              this.$refs.OrderAcceptDetail.setAcceptInfo(this.tradeApplyOrderVO)
            })


            // 评价
            if (this.tradeApplyInfoVO.tradeApplyEvaluateDTO) {
              this.$refs.OrderCommentInfo.setCommentInfo(
                this.tradeApplyInfoVO.tradeApplyEvaluateDTO
              )
            }

            this.defaultBuType = this.userInfo.defaultBuType
            this.employeeLevel = this.userInfo.employeeLevel

            // 门店完美门店参与资格
            if (this.tradeApplyExecStack) {
              this.tradeApplyBaseVO.isStack = Boolean(
                this.tradeApplyBaseVO.isStack
              )
            }

            // 门店PBO计划参与资格
            if (this.tradeApplyExecPboDTO) {
              this.tradeApplyExecPboDTO.attendStatus = Boolean(
                this.tradeApplyExecPboDTO.attendStatus
              )
            }

            // 选项权限
            this.setSelectAuth()
            // 按钮权限
            this.setBtnAuth()
            // 审批详情权限
            this.setDetailAuth()

            this.approvalFormData.tradeApplyDagFileList = this.tradeApplyOrderVO.tradeApplyDagFileList || []

            // 供应商列表
            this.getSupplier()
          }
        })
        .catch(() => {
          this.infoLoading = false
        })
    },

    // 获取供应商列表
    getSupplier () {
      const params = {
        vendorName: ''
      }
      this.$store.dispatch('getSupplier', params).then((res) => {
        if (res.data.resultCode === '0') {
          this.vendorList = res.data.resultData.vendorList || []
        }
      })
    },

    // 设置选项显示
    setSelectAuth () {
      this.expenseInfoShow = false
      this.budgetSelectShow = false
      this.supplementShow = false

      const solutionStatus = this.tradeApplyInfoVO.solutionStatus
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      const acceptanceStatus = this.tradeApplyInfoVO.acceptanceStatus

      // 预算
      if (
        this.isMineApproval &&
        ((applyStatus === '200' &&
          solutionStatus === '250') ||
          (this.tradeApplyInfoVO.applyClientLevel === 60 &&
            this.employeeLevel === 60 &&
            solutionStatus === '270') ||
          (this.isStarCustom && solutionStatus === '250')
        ) &&
        applyStatus === '200'
      ) {
        this.budgetSelectShow = true
      }

      // 审批概览显示
      if (
        applyStatus === '200' &&
        (solutionStatus === '210' || Number(solutionStatus) >= 250)
      ) {
        this.expenseInfoShow = true
      }

      // 补充信息显示
      if (this.tradeApplyOrderVO.applyType !== '02') {
        if (
          (this.isMineApply ||
            this.employeeLevel === 45 ||
            this.employeeLevel === 50 ||
            (this.defaultBuType === '03' && this.employeeLevel === 60)) &&
          Number(acceptanceStatus) < 420 &&
          (!this.tradeApplyBizVO.dianpinImage ||
            !this.tradeApplyBizVO.wccsId) &&
          applyStatus !== '900' &&
          applyStatus !== '0' &&
          !this.tradeApplyExecCooler &&
          !this.tradeApplyExecStack
        ) {
          this.supplementShow = true
        }
      } else {
        this.supplementShow = false
      }
    },

    // 设置按钮权限
    setBtnAuth () {
      this.canReject = false
      this.canPass = false
      this.canAccept = false
      this.canSupplier = false
      this.canReceipt = false
      this.supplierSelectShow = false
      this.supplierSelectShowOn130 = false
      // 驳回
      if (!this.tradeApplyExecStack) {
        // 非堆箱
        if (
          this.tradeApplyInfoVO.solutionStatus !== '210' &&
          this.tradeApplyInfoVO.acceptanceStatus !== '450' &&
          this.tradeApplyInfoVO.acceptanceStatus !== '410'
        ) {
          this.canReject = true
        }
      } else {
        // 堆箱
        if (
          this.tradeApplyInfoVO.requirementStatus === '120' ||
          this.tradeApplyInfoVO.requirementStatus === '130'
        ) {
          this.canReject = true
          this.canPass = true
        }
      }

      // 通过
      if (!this.tradeApplyExecStack) {
        // 非堆箱
        if (
          this.tradeApplyInfoVO.solutionStatus !== '210' &&
          this.tradeApplyInfoVO.applyStatus !== '400'
        ) {
          this.canPass = true
        }
      }

      // 验收
      if (
        this.tradeApplyInfoVO.solutionStatus !== '210' &&
        this.tradeApplyInfoVO.applyStatus === '400' &&
        this.tradeApplyInfoVO.acceptanceStatus === '420'
      ) {
        this.canAccept = true
      }

      // 提交供应商
      // 百威： 高端店招、物料定制 状态130/210，角色为45TM助理/50TM；
      // ISP： 303物料定制 状态140 角色60 BUISPTM； 301高端执行、302形象店 状态130 角色60 BUISPTM
      let execTypeSub = ''
      if (this.tradeApplyOrderVO.tradeApplyExecVO) {
        execTypeSub = this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub
      }
      if (
        this.tradeApplyOrderVO.applyType === '01' &&
        ((this.employeeLevel === 45 || this.employeeLevel === 50) &&
          (this.tradeApplyExecVO || this.tradeApplyExecCustom) &&
          !this.tradeApplyExecCooler) || (this.employeeLevel === 90 && this.tradeApplyExecVO?.execTypeSub && this.tradeApplyExecVO.execTypeSub === '202')
      ) {
        if (
          this.tradeApplyInfoVO.applyStatus === '100' &&
          this.tradeApplyInfoVO.requirementStatus === '130'
        ) {
          this.supplierSelectShowOn130 = true
          this.canPass = true
        }
        if (this.tradeApplyInfoVO.solutionStatus === '210') {
          this.canSupplier = true
          this.canPass = false
        }
      } else if (
        this.tradeApplyOrderVO.applyType === '03' &&
        this.tradeApplyInfoVO.applyStatus === '100' &&
        !this.tradeApplyInfoVO.vendorName
      ) {
        if (
          execTypeSub === '303' &&
          this.tradeApplyInfoVO.requirementStatus === '140' &&
          this.employeeLevel === 60
        ) {
          this.supplierSelectShow = true
          this.canPass = false
        } else if (
          this.tradeApplyInfoVO.requirementStatus === '130' &&
          (this.employeeLevel === 45 || this.employeeLevel === 50)
        ) {
          this.supplierSelectShow = true
          this.canPass = false
        }
      }

      // 确认收货
      if (
        (this.employeeLevel === 45 ||
          this.employeeLevel === 50 ||
          this.employeeLevel === 60 ||
          this.employeeLevel === 90) &&
        this.tradeApplyInfoVO.acceptanceStatus === '450'
      ) {
        this.canReceipt = true
      }

    },

    // 设置审批详情权限
    setDetailAuth () {
      this.planDetailShow = false
      this.acceptDetailShow = false

      if (this.tradeApplyOrderVO.applyType !== '03') {
        if (
          Number(this.tradeApplyInfoVO.solutionStatus) >= 220 &&
          !this.tradeApplyExecCooler
        ) {
          this.planDetailShow = true
        }
      } else {
        if (
          Number(this.tradeApplyInfoVO.requirementStatus) >= 140 &&
          this.tradeApplyInfoVO.vendorName
        ) {
          this.planDetailShow = true
        }
      }

      if (
        Number(this.tradeApplyInfoVO.acceptanceStatus) >= 420 &&
        !this.tradeApplyExecCooler &&
        this.employeeLevel >= 40
      ) {
        this.acceptDetailShow = true
      }
    },

    // 驳回
    handleReject () {
      this.dialogVisible = true
      this.handleText = ''
      this.handleType = 'reject'
    },

    // 通过
    async handlePass () {
      // this.tradeApplyInfoVO.applyStatus < 300

      if (this.needCheckPoc && this.basePocInfo.abiPocStatus === 2) {
        this.$confirm('单据无法通过，该门店已永久关店。请驳回单据，驳回后订单将自动关闭。', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '驳回',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.handleType = 'reject'
              this.handleConfirm(true)
            }

          }
        })
        return
      }

      // 选择预算
      if (this.budgetSelectShow) {
        if (this.orderQuotaPickerShow && (Number(this.tradeApplyInfoVO.quoteNonMenuAmount) >= 50000) && !this.approvalFormData.tradeApplyDagFileList?.length) {
          this.$message.error('请上传DAG凭证')
          return
        }
        if (!this.approvalFormData.trCode) {
          this.$message.error('请选择TRcode')
          return
        }
        if (!this.approvalFormData.mmr12) {
          this.$message.error('请选择MMR12')
          return
        }
        if (!this.approvalFormData.companyEntityCode) {
          this.$message.error('请选择所属工厂')
          return
        }
        if (!this.approvalFormData.costCenterCode) {
          this.$message.error('请选择成本中心')
          return
        }
        if (!this.approvalFormData.ledgerAccount) {
          this.$message.error('请选择总账科目')
          return
        }
        if(!this.approvalFormData.budgetMonth) {
          this.$message.error('请选择业务月份')
          return
        }

      }

      // 校验预算
      let approvalType = ''
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      if (applyStatus === '100') approvalType = '01'
      if (applyStatus === '200') approvalType = '02'
      if (applyStatus === '400') approvalType = '03'
      if (
        ['01','02','03'].includes(this.tradeApplyOrderVO.applyType) &&
        approvalType === '02' &&
        this.budgetSelectShow
      ) {
        const res = await this.handleCheckPrime('pass')
        if (res !== 1) return
      }

      if (
        (this.tradeApplyExecVO?.execTypeSub && ['102', '201'].includes(this.tradeApplyExecVO?.execTypeSub)) &&
        this.tradeApplyExecVO?.execTypeSub !== '202'
      ) {
        let canPass = false
        for (const i in this.tradeApplyOrderPocCheckInfo) {
          if (!this.checkStandardAll(this.tradeApplyOrderPocCheckInfo[i])) {
            canPass = true
          }
        }
        if (canPass) {
          let failItems = []
          let arr = Object.keys(this.tradeApplyOrderPocCheckInfo)
          arr.forEach(item => {
            let nonMatch = this.tradeApplyOrderPocCheckInfo[item].filter(val => val.isMatch === 0)
            if (nonMatch.length > 0) {
              failItems.push(item)
            }
          })

          this.$confirm(`该门店不符合${failItems.join('、')}选店标准, 请确认是否审批通过?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.dialogVisible = true
              this.handleText = ''
              this.handleType = 'pass'
            })
            .catch(() => { })
        } else {
          this.dialogVisible = true
          this.handleText = ''
          this.handleType = 'pass'
        }
      } else {
        this.dialogVisible = true
        this.handleText = ''
        this.handleType = 'pass'
      }
    },

    // 验收
    async handleAccept () {
      if (!this.tradeApplyInfoVO.tradeApplyEvaluateDTO && !this.hasComment) {
        this.$refs.OrderCommentDialog.commentShow()
        return
      }
      this.dialogVisible = true
      this.handleText = ''
      this.handleType = 'accept'
    },

    // 提交供应商
    handleSupplier () {
      if (this.needCheckPoc && this.basePocInfo.abiPocStatus === 2) {
        this.$confirm('单据无法通过，该门店已永久关店。请驳回单据，驳回后订单将自动关闭。', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '驳回',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.handleType = 'reject'
              this.handleConfirm(true)
            }

          }
        })
        return
      }
      if (this.tradeApplyExecCustom) {
        if (!this.approvalFormData.vendorId) {
          this.$message.error('请选择服务商')
          return
        }
        this.handleText = '是否确认分配该服务商?'
      } else {
        this.handleText = ''
      }

      this.dialogVisible = true
      this.handleType = 'supplier'
    },

    // 确认收货
    handleReceipt() {
      const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
      if (!inUse) {
        return this.$notify({
          title: '提示',
          message: '暂未开放，敬请期待',
          type: 'warning',
        })
      }

      const token = localStorageUtils.get('eb-token')
      const urlMap = {
        dev: 'https://icircle-dev.abipocm.com/login-auto',
        test: 'https://icircle-test.abipocm.com/login-auto',
        prod: 'https://icircle.abipocm.com/login-auto'
      }
      let url = urlMap[process.env.VUE_APP_ENV]
      if (!url) {
        return
      }
      if(!this.tradeApplyInfoVO.orderId){
        this.$message.error('缺少orderId')
        return
      }
      const targetUri = `/order/info?orderId=${this.tradeApplyInfoVO.orderId}`
      // window.open(`${url}?token=${token}&targetUri=${targetUri}`, '_blank')
      window.location.href = `${url}?token=${token}&targetUri=${targetUri}`
    },

    // 弹窗确认
    handleConfirm (notCheckRemark) {
      if (this.btnLoading) {
        return
      }
      let approvalType = ''
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      if (applyStatus === '100') approvalType = '01'
      if (applyStatus === '200') approvalType = '02'
      if (applyStatus === '400') approvalType = '03'
      this.approvalFormData.applyId = this.tradeApplyOrderVO.applyId
      this.approvalFormData.approvalType = approvalType
      this.approvalFormData.processClientId = this.userInfo.clientId
      this.approvalFormData.processClientName = this.userInfo.clientName

      // 审批驳回
      if (this.handleType === 'reject') {
        this.successText = '订单驳回成功'

        if (!this.approvalFormData.processRemark && !notCheckRemark) {
          this.$message.error('请填写驳回理由')
          return
        }
        this.approvalFormData.approvalResult = '03'
      }

      // 审批通过
      if (this.handleType === 'pass') {
        this.successText = '订单审批成功'
        this.approvalFormData.type = '02'

        // 选择服务商
        if (
          (this.supplierSelectShow || this.supplierSelectShowOn130) &&
          !this.approvalFormData.vendorId
        ) {
          this.$message.error('请选择服务商')
          return
        }

        // 选择预算
        if (this.budgetSelectShow) {
          if (!this.approvalFormData.trCode) {
            this.$message.error('请选择TRcode')
            return
          }
          if (!this.approvalFormData.mmr12) {
            this.$message.error('请选择MMR12')
            return
          }
          if (!this.approvalFormData.companyEntityCode) {
            this.$message.error('请选择所属工厂')
            return
          }
          if (!this.approvalFormData.costCenterCode) {
            this.$message.error('请选择成本中心')
            return
          }
          if (!this.approvalFormData.ledgerAccount) {
            this.$message.error('请选择总账科目')
            return
          }
          if(!this.approvalFormData.budgetMonth) {
            this.$message.error('请选择业务月份')
            return
          }

        }

        this.approvalFormData.tradeApplyExecCoolerList = []

        this.approvalFormData.approvalResult = '02'
      }

      // 审批验收
      if (this.handleType === 'accept') {
        this.successText = '订单验收成功'
        this.approvalFormData.approvalResult = '02'
      }

      // 分配服务商
      if (this.handleType === 'supplier') {
        if (!this.approvalFormData.vendorId) {
          this.$message.error('请选择服务商')
          return
        }
        this.successText = '分配服务商成功'
        if (this.tradeApplyOrderVO.applyType !== '03') {
          this.btnLoading = true
          this.$store
            .dispatch('submitSupplier', this.approvalFormData)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
          return
        } else {
          this.approvalFormData.approvalResult = '02'
          this.successText = '分配服务商成功'
        }
      }

      // 确认收货
      if (this.handleType === 'receipt') {
        const formData = {
          applyId: this.tradeApplyOrderVO.applyId
        }
        this.successText = '收货成功'
        this.btnLoading = true
        this.$store
          .dispatch('handleReceipt', formData)
          .then((res) => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              this.dialogVisible = false
              this.succVisible = true
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
        return
      }


      // 调用接口
      if (this.tradeApplyOrderVO.applyType !== '03') {
        if (
          this.tradeApplyOrderVO.applyType === '02' &&
          this.tradeApplyInfoVO.clientType === '02'
        ) {
          // isp批量化物料
          this.btnLoading = true
          this.$store
            .dispatch('handleIspApprove', this.approvalFormData)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else if (this.tradeApplyOrderVO.applyType === '04') {
          // pbo
          this.btnLoading = true
          const data = {
            applyId: this.approvalFormData.applyId,
            approvalResult: this.approvalFormData.approvalResult,
            processRemark: this.approvalFormData.processRemark
          }
          this.$store
            .dispatch('handlePboApprove', data)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else {
          // 百威
          this.btnLoading = true
          this.$store
            .dispatch('handleApprove', this.approvalFormData)
            .then((res) => {
              this.btnLoading = false
              if (res.data.resultCode === '0') {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      } else {
        // ISP
        this.btnLoading = true
        this.$store
          .dispatch('handleIspApprove', this.approvalFormData)
          .then((res) => {
            this.btnLoading = false
            if (res.data.resultCode === '0') {
              this.dialogVisible = false
              this.succVisible = true
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      }
    },

    // 返回订单列表
    returnList () {
      this.$router.go(-1)
    },

    // 查看详情
    showInfo () {
      this.succVisible = false
      this.init()
      this.approvalFormData.vendorId = ''
    },

    collClick (index) {
      if (!index) {
        this.orderShow = !this.orderShow
      } else if (index === 1) {
        this.processShow = !this.processShow
      } else if (index === 2) {
        this.planShow = !this.planShow
      } else if (index === 3) {
        this.acceptShow = !this.acceptShow
      } else if (index === 4) {
        this.quotaShow = !this.quotaShow
      } else if (index === 5) {
        this.investmentShow = !this.investmentShow
      } else if (index === 6) {
        this.buQuotaShow = !this.buQuotaShow
      }
    },

    // 门店完美门店参与资格
    stackSwitch () {
      if (this.tradeApplyBaseVO.isStack) {
        this.$confirm('请确认是否关闭门店完美门店参与资格', '提示', {
          showCancelButton: true,
          cancelButtonText: '暂不关闭',
          confirmButtonText: '残忍关闭'
        }).then(() => {
          this.$confirm('请确认是否关闭门店完美门店参与资格', '提示', {
            showCancelButton: true,
            cancelButtonText: '暂不关闭',
            confirmButtonText: '残忍关闭'
          }).then(() => {
            this.$store
              .dispatch('setTrade', this.tradeApplyInfoVO.applyNumber)
              .then((res) => {
                if (res.data.resultCode === '0') {
                  this.init()
                }
              })
          })
        })
      } else {
        if (this.employeeLevel !== 50) {
          return
        }
        this.$confirm('请确认是否开启门店堆箱计划参与资格', '提示', {
          showCancelButton: true,
          cancelButtonText: '暂不开启',
          confirmButtonText: '确认开启'
        }).then(() => {
          this.$store
            .dispatch('enableTrade', this.tradeApplyInfoVO.applyNumber)
            .then((res) => {
              if (res.data.resultCode === '0') {
                this.init()
              }
            })
        })
      }
    },

    // PBO参与资格
    pboSwitch () {
      const params = {
        applyId: this.tradeApplyInfoVO.applyId
      }
      if (this.tradeApplyExecPboDTO.attendStatus) {
        this.$confirm('请确认是否禁用该PBO计划', '提示', {
          showCancelButton: true,
          cancelButtonText: '暂不禁用',
          confirmButtonText: '残忍禁用'
        }).then(() => {
          this.$confirm('请确认是否禁用该PBO计划', '提示', {
            showCancelButton: true,
            cancelButtonText: '暂不禁用',
            confirmButtonText: '残忍禁用'
          }).then(() => {
            this.$store.dispatch('disablePbo', params).then((res) => {
              if (res.data.resultCode === '0') {
                this.init()
              }
            })
          })
        })
      } else {
        if (this.employeeLevel !== 30) {
          return
        }
        this.$confirm('请确认是否开启该PBO计划', '提示', {
          showCancelButton: true,
          cancelButtonText: '暂不开启',
          confirmButtonText: '确认开启'
        }).then(() => {
          this.$store.dispatch('enablePbo', params).then((res) => {
            if (res.data.resultCode === '0') {
              this.init()
            }
          })
        })
      }
    },

    qualityClick (val) {
      this.commentParams.qualityScoreValue = val
    },

    speedClick (val) {
      this.commentParams.speedScoreValue = val
    },

    commentSuccess () {
      this.hasComment = true
      this.handleAccept()
    },
    tableBorderRight ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3) {
        return 'border-right:1px solid #EBEEF5;'
      }
    },
    // 门店选店标准审核检查
    tradeApplyApproveInfo () {
      this.$store
        .dispatch('tradeApplyApproveInfo', this.$route.query.applyId)
        .then((res) => {
          if (res.data.resultCode === '0') {
            this.tradeApplyOrderPocCheckInfo =
              res.data.resultData.tradeApplyOrderVO.tradeApplyOrderPocCheckResultMap
            this.historyInvestmentInfo = res.data.resultData.reportMap
          }
        })
    },
    // 门店校验标准信息
    // getApprovePocCheckStandard (type) {
    //   this.$store.dispatch('getApprovePocCheckStandard', type).then(res => {
    //     if (res.data.resultCode === '0') {
    //       if (type === '102') {
    //         let obj = res.data.resultData.pocStandardResultMap
    //         let info = {}
    //         for (const i in obj) {
    //           obj[i].forEach(item => {
    //             item.coolerName = item.channelCode
    //             if (!info[item.channelCode]) {
    //               info[item.channelCode] = [item]
    //             } else {
    //               info[item.channelCode].push(item)
    //             }
    //           })
    //         }
    //         let list = []
    //         for (const i in info) {
    //           list.push(info[i])
    //         }
    //         this.completeStandardInfo = list.flat()
    //       } else {
    //         this.completeStandardInfo = res.data.resultData.pocStandardResultMap['普通']
    //       }
    //     }
    //   })
    // },
    // 判断门店是否符合所有标准
    checkStandardAll (list) {
      return list.every((item) => {
        return item.isMatch === 1
      })
    },
    showCompleteStandard () {
      this.completeStandardDialog = true
    },
    // 表格样式
    tableHeaderRowClassName ({ rowIndex }) {
      if (rowIndex === 0) {
        return 'quota-table-row-0'
      }
      if (rowIndex === 1) {
        return 'quota-table-row-1'
      }
    },

    // DAG上传凭证
    handleUploadSuccess ({ fileId, fileUri, originalName }) {
      const fileInfo = {
        fileName: originalName,
        fileId,
        fileUri
      }
      const flag = this.approvalFormData.tradeApplyDagFileList.some(
        (item) => item.fileId === fileId
      )
      if (!flag) {
        this.approvalFormData.tradeApplyDagFileList.push(fileInfo)
      }
    },

    // 删除DAG凭证
    handleFileRemove ({ fileId }) {
      this.approvalFormData.tradeApplyDagFileList =
        this.approvalFormData.tradeApplyDagFileList.filter(
          (item) => item.fileId !== fileId
        )
    },

    // pr预算校验
    handleCheckPrime(handleType){
      let approvalType = ''
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      if (applyStatus === '100') approvalType = '01'
      if (applyStatus === '200') approvalType = '02'
      if (applyStatus === '400') approvalType = '03'
      return new Promise((resolve, reject) => {
        if (this.infoLoading) {
          resolve(0)
          return
        }
        let purchasePriceNet = ''
        if(approvalType === '02'){
          purchasePriceNet = this.tradeApplyInfoVO.quoteAmount
        }else if(approvalType === '03'){
          purchasePriceNet = this.tradeApplyOrderVO.applyType === '01' ? this.tradeApplyInfoVO.quoteAmount : this.tradeApplyInfoVO.actualAmount
        }
        const params = (() => {
          if(this.budgetSelectShow){
            return Object.assign({}, {
              'trCode': this.approvalFormData.trCode,
              "mmr12Code": this.approvalFormData.mmr12,
              "regionCode": this.tradeApplyInfoVO.regionCode,
              purchasePrDetailList: [{
                "purchaseQty": 1,
                "purchasePriceNet": purchasePriceNet,
                "budgetMonth": this.approvalFormData.budgetMonth
              }]
            })
          }else{
            return Object.assign({}, {
              'trCode': this.tradeApplyInfoVO.trCode,
              "mmr12Code": this.tradeApplyInfoVO.mmr12,
              "regionCode": this.tradeApplyInfoVO.regionCode,
              purchasePrDetailList: [{
                "purchaseQty": 1,
                "purchasePriceNet": purchasePriceNet,
                "budgetMonth": this.tradeApplyInfoVO.budgetMonth
              }]
            })
          }
        })()

        this.infoLoading = true
        tradeApi.checkPrPrime(params).then(res => {
          this.infoLoading = false
          if (res.data.resultCode === '0') {
            const { budgetCheckPassed ,budgetCheckFailed } = res.data.resultData
            this.budgetCheckPassed= budgetCheckPassed || ''
            this.budgetCheckFailed = budgetCheckFailed || ''
            if(this.budgetCheckPassed && (handleType === 'pass' || handleType === 'accept')){
              resolve(1)
            }else{
              this.$refs["OrderBudgetDialog"].open()
            }
          }
          resolve(0)
        }).catch(() => {
          this.infoLoading = false
          resolve(0)
        })
      })

    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 430px;
}
.content-container {
  padding-bottom: 20px;
}
.info-title {
  font-size: $font-16;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 10px;

  i {
    font-weight: bold;
  }
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  line-height: 100px;
  background: #f3f5f9;
  z-index: 10;
}
.info-btn {
  text-align: center;
  height: 42px;
  .el-button {
    padding-left: 40px;
    padding-right: 40px;
    margin: 10px 25px 0 25px;
  }
}

.block-content {
  line-height: 30px;
}

::v-deep .el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: pointer !important;
}

::v-deep .el-switch.is-disabled {
  opacity: 1;
}
.standard-title {
  font-size: 0px;
  color: #cacbca;
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: inline-block;
  line-height: 18px;
  img {
    width: 100%;
  }
}
.investment-table {
  width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  margin-top: 30px;
  border-collapse: collapse;
  line-height: 23px;
  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    img {
      width: 100%;
    }
  }
  th {
    padding: 12px 0;
    background: #f5f7fa;
    color: rgb(56, 55, 55);
  }
  td {
    // width: 130px;
    text-align: center;
    border: 1px solid #ebeef5;
    padding: 12px 0;
    box-sizing: border-box;
    color: #606266;
    &:nth-child(1) {
      width: 205px;
    }
    &:nth-child(2) {
      width: 400px;
    }
    &:nth-child(3) {
      width: 400px;
    }
    &:nth-child(2) {
      width: 400px;
    }
  }
  .isMeet {
    color: #3faa1d;
  }
  .Meet {
    color: #f29613;
  }
}
</style>
<style lang="scss">
.el-message-box .el-message-box__btns {
  margin-top: 20px;
  text-align: center;
  .el-button--primary {
    background-color: #c8102d;
    border-color: #c8102d;
  }
}
.el-message-box__wrapper {
  bottom: 350px;
}
.history-investment-box {
  display: flex;
  text-align: center;
  border: 1px solid #ebeef5;
  margin-top: 20px;
  border-radius: 5px;
  .history-investment {
    border-right: 1px solid #ebeef5;
    flex: 1;
    .investment-title {
      font-size: 18px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0 10px;
      border-bottom: 1px solid #ebeef5;
      span {
        &:last-child {
          color: #c8102d;
          font-weight: 700;
          line-height: 35px;
        }
      }
    }
    .investment-content {
      padding: 0 60px;
      div {
        display: flex;
        justify-content: space-around;
        padding: 16px 0;
      }
    }
  }
}
.trade-order-block .content-row {
  margin-top: 15px;
}
</style>
<style lang="scss">
.complete-standard-info {
  img {
    width: 100%;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
}
// .el-table thead.is-group th.el-table__cell{
//   background-color: #fff;
// }
.quota-table-row-0 th {
  border-right: 0 !important;
  color: rgb(56, 55, 55);
}
.quota-table-row-1 th {
  // color: red;
  background-color: #fff !important;
}
// .quota-table-row th.el-table__cell{
//       //  background-color: #fff;
// }
</style>
